import {
  GetSubCategoriesOptions,
  SaveCategoryOperationMode,
  BaseApiRequest,
  GetSubCategoryResponse,
  reorderSubCategories,
  getSubCategoriesByIds,
  getSubCategoriesByTopLevelCategory,
  getSubCategory,
  getSubCategoryCompletion,
  saveSubCategory,
} from "@robe/core-api";
import { SubCategory, Content } from "@robe/core-types";
import { XcoreCore } from ".";

export class XcoreSubCategory {
  private core: XcoreCore;

  public constructor(core: XcoreCore) {
    this.core = core;
  }

  /**
   * Localized sub categories names are filled with `en` value if value is not available for some locale in sub categories, only on WEB.
   */
  public listByTopLevelCategory<T extends Content | never>(
    topLevelCategory: string,
    options?: GetSubCategoriesOptions<T>
  ): BaseApiRequest<SubCategory[]> {
    return getSubCategoriesByTopLevelCategory<T>(topLevelCategory, this.core, options);
  }

  /**
   * Localized sub categories names are filled with `en` value if value is not available for some locale in sub categories, only on WEB.
   */
  public listByIds(ids: number[]): BaseApiRequest<GetSubCategoryResponse[]> {
    return getSubCategoriesByIds(ids, this.core);
  }

  /**
   * Localized sub categories names are filled with `en` value if value is not available for some locale in sub categories, only on WEB.
   */
  public singleById(id: number): BaseApiRequest<GetSubCategoryResponse> {
    return getSubCategory(id, this.core);
  }

  /**
   * Localized sub categories names are filled with `en` value if value is not available for some locale in sub categories, only on WEB.
   */
  public completion(id: string, term: string, locale: string): BaseApiRequest<SubCategory[]> {
    return getSubCategoryCompletion(id, term, locale, this.core);
  }

  public insert(category: SubCategory): BaseApiRequest<SubCategory> {
    return saveSubCategory(category, this.core, SaveCategoryOperationMode.Create);
  }

  public reorder(type: string, order: number[] | Record<string, number>): BaseApiRequest<SubCategory[]> {
    return reorderSubCategories(type, order, this.core);
  }

  public update(category: SubCategory): BaseApiRequest<SubCategory> {
    return saveSubCategory(category, this.core, SaveCategoryOperationMode.Update);
  }
}
